import { Loader2 } from "lucide-react";

export function LoadingScreen() {
  return (
    <div className="loading-screen" id="dealer-loading">
      <div className="loading-logo">
        <Loader2
          size={36}
          style={{ color: "var(--ev-blue-600)", animation: "spin 1s linear infinite" }}
        />
        <span className="loading-brand">evocha</span>
        <span className="loading-text">Super Dealer</span>
      </div>
      <div className="loading-bar-track">
        <div className="loading-bar-fill" />
      </div>
    </div>
  );
}
